import * as React from "react";
import { LoadingContainer } from "./styles";
class Loading extends React.Component {
    render() {
        const { style = {} } = this.props;
        return (React.createElement(LoadingContainer, { style: style },
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null)));
    }
}
export default Loading;
